<!--
 * @Description: 图片
 * @Author: PF
 * @Date: 2025-05-29 09:06:06
 * @LastEditors: PF
 * @LastEditTime: 2026-08-12 11:01:33
-->
<template>
  <!-- {{ baseUrl + img }} -->
  <el-image class="avatar" :src="baseUrl + img" :fit="fit" :style="'width: ' + wid + ';height: ' + hei">
    <template #error>
      <div class="image-slot">
        <span class="iconfont icon-tupian" :style="'font-size: ' + siz + ';color:' + col"></span>
      </div>
    </template>
  </el-image>
</template>
<script setup>
import { ref, defineProps } from 'vue'
const props = defineProps({
  img: { type: String, required: true, default: '' },
  fit: { type: String, required: false, default: 'contain' }, // '' | 'fill 拉伸' | 'contain 等比例缩放完整留白' | 'cover 等比例缩放超出裁剪' | 'none 原始尺寸' | 'scale-down 取尺寸较小的显示方式'
  wid: { type: String, required: false, default: '100%' },
  hei: { type: String, required: false, default: '100%' },
  col: { type: String, required: false, default: '' },
  siz: { type: String, required: false, default: '3em' }
})

const baseUrl = ref(process.env.VUE_APP_BASE_API)

</script>
